import DatetimeUtils from "../../gd/utils/datetime-utils"
import {NoteType} from "./@const";

export const DEFAULT_TITLE = 'Notes'

export default class Note {

    public id               : ID
    public type             : NoteType | null
    public title            : string
    public access           : 0 | 1     // gd.const.meeting.noteAccess
    public momentCreated    : Moment
    public userId           : ID
    public contentText      : string
    public contentRtf       : any
    public whiteboard       : any

    constructor(data:any) {

        this.id             = _.get(data, 'id',               '')
        this.type           = _.get(data, 'type',             null)
        this.title          = _.get(data, 'title',            DEFAULT_TITLE)
        this.access         = _.get(data, 'access',           gd.const.meeting.noteAccess.PRIVATE)
        this.momentCreated  = DatetimeUtils.datetimeToMoment(_.get(data, 'momentCreated',    null))
        this.userId         = _.get(data, 'userId',           gd.session.me.id)
        this.contentText    = _.get(data, 'contentText',      '')
        this.contentRtf     = _.get(data, 'contentRtf',       null)
        this.whiteboard     = _.get(data, 'whiteboard',       null)
    }

    get rid():string {
        return 'note-'+this.id
    }

    static async create(meetingId:ID, title: string, access: 0 | 1) {
        const response = await gd.api.Meeting.meetingAddNote(meetingId, title, access, '', {}).promise()
        return new Note(response)
    }

    setContent = (text:string, rtf:any) => {
        this.contentText    = text
        this.contentRtf     = rtf
    }

    get isEmpty() {
        return _.isEmpty(this.contentText)
    }

    toJSON = () => {

        return {
            id              : this.id,
            type            : this.type,
            title           : this.title,
            access          : this.access,
            userId          : this.userId,
            momentCreated   : DatetimeUtils.momentToUTCISODatetime(this.momentCreated),
            contentText     : this.contentText,
            contentRtf      : this.contentRtf,
            whiteboard      : this.whiteboard,
        }

        // return _.pick(this, 'id', 'title', 'access', 'userId', 'contentText', 'contentRtf','momentCreated')
    }
}
